import { createGlobalStyle } from 'styled-components';
import { themeGet } from 'styled-system';
import { normalize } from 'polished';
const BaseStyle = createGlobalStyle`
  ${normalize()}

  * {
    box-sizing: border-box;
    font-family: HarmoniaSans, Helvetica, Arial, sans-serif;
  }

  ::placeholder {
    color: ${themeGet('colors.text.lightGray')};
  }

  @font-face {
    font-family: 'HarmoniaSans';
    src: url('https://d6eityk6fvarl.cloudfront.net/fonts/regular/HarmoniaSansStd-Regular.eot');
    src: url('https://d6eityk6fvarl.cloudfront.net/fonts/regular/HarmoniaSansStd-Regular.otf') format('opentype'),
    url('https://d6eityk6fvarl.cloudfront.net/fonts/regular/HarmoniaSansStd-Regular.woff2') format('woff2'), 
    url('https://d6eityk6fvarl.cloudfront.net/fonts/regular/HarmoniaSansStd-Regular.woff') format('woff'),
    url('https://d6eityk6fvarl.cloudfront.net/fonts/regular/HarmoniaSansStd-Regular.ttf') format('truetype');
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'HarmoniaSans';
    src: url('https://d6eityk6fvarl.cloudfront.net/fonts/semibold/HarmoniaSansStd-SemiBd.eot');
    src: url('https://d6eityk6fvarl.cloudfront.net/fonts/semibold/HarmoniaSansStd-SemiBd.otf') format('opentype'),
    url('https://d6eityk6fvarl.cloudfront.net/fonts/semibold/HarmoniaSansStd-SemiBd.woff2') format('woff2'), 
    url('https://d6eityk6fvarl.cloudfront.net/fonts/semibold/HarmoniaSansStd-SemiBd.woff') format('woff'),
    url('https://d6eityk6fvarl.cloudfront.net/fonts/semibold/HarmoniaSansStd-SemiBd.ttf') format('truetype');
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: 'HarmoniaSans';
    src: url('https://d6eityk6fvarl.cloudfront.net/fonts/bold/HarmoniaSansStd-Bold.eot');
    src: url('https://d6eityk6fvarl.cloudfront.net/fonts/bold/HarmoniaSansStd-Bold.otf') format('opentype'),
    url('https://d6eityk6fvarl.cloudfront.net/fonts/bold/HarmoniaSansStd-Bold.woff2') format('woff2'), 
    url('https://d6eityk6fvarl.cloudfront.net/fonts/bold/HarmoniaSansStd-Bold.woff') format('woff'),
    url('https://d6eityk6fvarl.cloudfront.net/fonts/bold/HarmoniaSansStd-Bold.ttf') format('truetype');
    font-weight: 600;
    font-display: swap;
  }

  @font-face {
    font-family: 'HarmoniaSans';
    src: url('https://d6eityk6fvarl.cloudfront.net/fonts/black/HarmoniaSansStd-Black.eot');
    src: url('https://d6eityk6fvarl.cloudfront.net/fonts/black/HarmoniaSansStd-Black.otf') format('opentype'),
    url('https://d6eityk6fvarl.cloudfront.net/fonts/black/HarmoniaSansStd-Black.woff2') format('woff2'),
    url('https://d6eityk6fvarl.cloudfront.net/fonts/black/HarmoniaSansStd-Black.woff') format('woff'),
    url('https://d6eityk6fvarl.cloudfront.net/fonts/black/HarmoniaSansStd-Black.ttf') format('truetype');
    font-weight: 800;
    font-display: swap;
  }
`;
export default BaseStyle;